const spacesContent = {
  introduction: "Naše škola nabízí bezpečné prostory navržené speciálně pro děti školního věku. Každá místnost je vybavena tak, aby podporovala kreativitu, učení a hru dětí. Snažíme se dodržovat montessori přístup o připraveném prostředí pro děti.",

  spaces: [
    {
      id: 1,
      name: "Třída prvního trojročí",
      image: "/images/school_main_room.jpg",
      alt: "Třída prvního trojročí ve škole Maryam",
      description: "Je to místnost, kde se každé ráno setkávají všechny děti a učitelé. Probíhá zde výuka dětí 1. trojročí od 9 do 12 hod. Místnost je rozdělena dle jednotlivých oblastí na Matematiku a geometrii, Psaní, Český jazyk a Svět. V těchto oblastech jsou přichystány pomůcky k procvičení či vysvětlení učiva. Najdeme zde zázemí pro učitele, prostory pro sešity a pomůcky žáků, knihovnu, čtecí koutek, elipsu, tabuli a televizní obrazovku."
    },
    {
      id: 2,
      name: "Třída druhého trojročí",
      image: "/images/school_second_room.jpg",
      alt: "Třída druhého trojročí ve škole Maryam",
      description: "Zde probíhá výuka žáků druhého trojročí od 9 do 12 hodin. Všechny potřebné pomůcky si sem nosíme z vedlejší třídy. Máme zde k dispozici i odpočinkový kout. V této místnosti je nově zřízena výdejna obědů, které dovážíme ze SŠ Slavkov Austerlitz."
    }
  ],

  gallery: {
    id: 'gallery',
    name: 'Fotogalerie',
    description: 'Prohlédněte si naši školu v obrazech',
    photos: [
      {
        id: 1,
        image: '/images/spaces/cesky_jazyk_svet_knihovna_misto_pro_veci_deti.jpg',
        caption: 'Český jazyk, svět, knihovna, místo pro věci dětí'
      },
      {
        id: 2,
        image: '/images/spaces/cteci_koutek.jpg',
        caption: 'Čtecí koutek'
      },
      {
        id: 3,
        image: '/images/spaces/oblast_cesky_jazyk_a_psani.jpg',
        caption: 'Oblast český jazyk a psaní'
      },
      {
        id: 4,
        image: '/images/spaces/oblast_matematika.jpg',
        caption: 'Oblast matematika'
      },
      {
        id: 5,
        image: '/images/spaces/oblast_matematiky.jpg',
        caption: 'Oblast matematiky'
      },
      {
        id: 6,
        image: '/images/spaces/oblast_svet_a_misto_pro_veci_deti.jpg',
        caption: 'Oblast svět a místo pro věci dětí'
      },
      {
        id: 7,
        image: '/images/spaces/oblast_svet_a_misto_pro_veci_deti_2.jpg',
        caption: 'Oblast svět a místo pro věci dětí'
      },
      {
        id: 8,
        image: '/images/spaces/pomucky_cj.jpg',
        caption: 'Pomůcky ČJ'
      },
      {
        id: 9,
        image: '/images/spaces/satny.jpg',
        caption: 'Šatny'
      },
      {
        id: 10,
        image: '/images/spaces/ucitelske_misto_a_cteci_koutek.jpg',
        caption: 'Učitelské místo a čtecí koutek'
      },
      {
        id: 11,
        image: '/images/spaces/uklizeci_koutek.jpg',
        caption: 'Uklízecí koutek'
      },
      {
        id: 12,
        image: '/images/spaces/vstup_do_tridy_1_trocroci.jpg',
        caption: 'Vstup do třídy 1. trojročí'
      }
    ]
  }
};

export default spacesContent;
